import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Shower(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M9.027 6H7a1 1 0 000 2h6a1 1 0 100-2h-1.95a2.5 2.5 0 012.45-2h.5a3 3 0 013 3v13H3a1 1 0 100 2h18a1 1 0 100-2h-2V7a5 5 0 00-5-5h-.5a4.5 4.5 0 00-4.473 4zm.723 3.005a.75.75 0 01.75.75v1.495a.75.75 0 01-1.5 0V9.755a.75.75 0 01.75-.75zm-3 1.01a.75.75 0 01.75.75v1.476a.75.75 0 01-1.5 0v-1.477a.75.75 0 01.75-.75zm6.5 0a.75.75 0 01.75.75v1.476a.75.75 0 01-1.5 0v-1.477a.75.75 0 01.75-.75zm-2.75 4.731a.75.75 0 00-1.5 0v1.504a.75.75 0 001.5 0v-1.504zm-3 1.01a.75.75 0 00-1.5 0v1.494a.75.75 0 001.5 0v-1.495zm6.5 0a.75.75 0 00-1.5 0v1.494a.75.75 0 001.5 0v-1.495z",
    clipRule: "evenodd"
  }));
}

export default Shower;